import { useState } from "react";

import { PortableText } from "@portabletext/react";
import { UnderlineLink } from "../hooks/usePortableTextComponents";

const Info = (props) => {
  const { pageData, infoOpen, setInfoOpen } = props;

  // const [infoOpen, setInfoOpen] = useState(false);

  const toggleInfo = () => {
    setInfoOpen((prev) => !prev);
  };

  return (
    <>
      <div className="info__title bold">{pageData.title}</div>
      <button className="info__button bold" onClick={toggleInfo}>
        {/* <div className={`info__burger ${infoOpen ? "active" : ""}`} /> */}
        Info
      </button>
      <header className="info__header-bar" />

      <section
        className={`info__wrapper ${infoOpen ? "active" : ""}`}
        onClick={toggleInfo}
      >
        <div className="info__text-wrapper">
          <div className="info__text-item about">
            <PortableText value={pageData.about} components={UnderlineLink} />
          </div>
          <div className="info__text-item">Get in touch:</div>
          <div className="info__text-item links">
            <a href={`mailto:${pageData.emailAddress}`}>
              {pageData.emailAddress}
            </a>
          </div>
          <div className="info__text-item">Follow:</div>
          <div className="info__text-item links">
            {pageData.socials.map((social, index) => (
              <a
                key={index}
                href={social.entryLink}
                target="_blank"
                rel="noreferrer"
                className="info__item-link"
              >
                {social.entryName}
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Info;
